export default __webpack_public_path__ + "static/07-b14ec96695ad42e3086e4e1c2b9c75f8.png";